import React, { Component } from 'react';
// import IconSet34 from 'components/Icon/IconSet34';
// import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
// import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

// import IconAccount from '@material-ui/icons/AccountBox';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { Fade } from '@material-ui/core';
// import { ClickAwayListener } from '@material-ui/core';

import { isLoggedIn, getCurrentUserRole } from 'ducks/authentication';

// import IconSetMenu from 'components/Icon/IconSetMenu';

const styles = (theme) => {
  return {
    root: {
      position: 'relative',
    },
  };
};
class HeaderLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
  }
  _toggle = () => {
    const { opened } = this.state;
    const newOpened = opened === true ? false : true;
    console.log({ opened, newOpened });
    this.setState({ opened: newOpened });
  };
  _goto = (page) => {
    this.props.history.push('/' + page);
  };
  render() {
    const { userRole, classes, loggedIn } = this.props;
    const { opened } = this.state;
    return (
      <If condition={loggedIn === true}>
        <div className={classes.root}>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={this._toggle}
            ref={(r) => (this.$anchorEl = r)}
          >
            Mon compte
          </Button>
          <Menu
            id="HeaderLogin"
            anchorEl={this.$anchorEl}
            keepMounted
            open={opened}
            onClose={this._toggle}
            TransitionComponent={Fade}
          >
            <If condition={userRole !== 'admin'}>
              <MenuItem onClick={(e) => this._goto('')}>Votre espace personnel</MenuItem>
            </If>
            <If condition={userRole === 'admin'}>
              <MenuItem onClick={(e) => this._goto('')}>Admin</MenuItem>
            </If>
            <MenuItem onClick={(e) => this._goto('logout')}>Deconnexion</MenuItem>
          </Menu>
        </div>
      </If>
    );
  }
}

// export default HeaderLogin;
function mapStateToProps(state) {
  const props = {
    loggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}

// export default HeaderMenu;
export default connect(mapStateToProps)(withRouter(withStyles(styles)(HeaderLogin)));



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLogin.jsx